export default __webpack_public_path__ + "static/media/info-circle-white.90b1b040.svg";